import { css } from 'styled-components';
import { responsiveProperty } from '../../utils/responsiveProperty/responsiveProperty.js';

function getCellCSS(values) {
  var _css;
  if (!values) {
    return undefined;
  }
  var property = 'gridColumn';
  if (typeof values !== 'number') {
    var modifiedValues = Object.keys(values).reduce(function (acc, key) {
      var _Object$assign;
      return Object.assign(Object.assign({}, acc), (_Object$assign = {}, _Object$assign[key] = "span " + values[key], _Object$assign));
    }, {});
    var cssObject = responsiveProperty(property, modifiedValues);
    return cssObject;
  }
  return css((_css = {}, _css[property] = "span " + values, _css));
}

export { getCellCSS };
